import genericStore from "../generic_store";
import jsonToFormData from "@ajoelp/json-to-formdata";
import axios from "axios";
import {config} from "@/config/constants";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "memberships",
    object: "membership",
    header: [
      { text: "ID", value: "id" },
      { text: "Instalane User Email", value: "email" },
      { text: "First Name", value: "first_name" },
      { text: "Last Name", value: "last_name" },
      { text: "Membership Number", value: "membership_number" },
      { text: "Date", value: "date" },
      { text: "Client ID", value: "client_id" },
      { text: "Verified", value: "verified" },
      { text: "Bulk Actions", value: "bulk_actions" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    bulk({ commit, state }, data) {
      let saveData = {};
      saveData = data;
      return new Promise((resolve, reject) => {
        commit("request");
        const formData = jsonToFormData(saveData, {
          arrayIndexes: true,
          excludeNull: true,
        });
        axios
            .put(config.api_url + state.endpoint + "_bulk", formData)
            .then((response) => {
              commit("success");
              resolve(response.data);
            })
            .catch((error) => {
              commit("error");
              reject(error.response.data);
            });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
